// import siteInfo from "@/constants/siteInfo";
import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const PersonSchema = ({
  authorName = "",
  authorCanonicalUrl = "",
}) => {
  return (
    <Head>

      <script
        id="PersonSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: authorName,
            url:  authorCanonicalUrl?.includes(
                        process.env.NEXT_PUBLIC_WEBSITE_URL
                      )
                        ? `${authorCanonicalUrl}`
                        : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,

            worksFor: {
                "@type": "Organization",
                name: siteInfo?.siteName,
                url: process.env.NEXT_PUBLIC_WEBSITE_URL
            }
          }),
        }}
      />
    </Head>
  );
};

export default PersonSchema;
